export default __webpack_public_path__ + "assets/LiveXR360_bh.png";